import initSlider from '../sliders/initSlider';
import { thumbsSliderOptions, accountInfoSliderOptions, assetInfoSliderOptions } from '../sliders/sliders';

import initSimpleParallax from '../parallax/initSimpleParallax';
import { parallaxHorizontalOptions, parallaxVerticalOptions } from '../parallax/parallax';

import initAccordion from '../initAccordion';

/*  */

// const DESIGN_PIECES = [
//   { sprite: 'gold_bokeh', x: 1093.8, y: 62.81, angle: -0.2762, scale: 1, mirror: 1, blurry: true },
//   { sprite: 'mint_bokeh', x: 110.85, y: 229.33, angle: -0.3984, scale: 1, mirror: 1, blurry: true },
//   { sprite: 'gold_sharp', x: 1326.38, y: 371.7, angle: -0.1619, scale: 1, mirror: 1 },
//   { sprite: 'gold_soft', x: 83.55, y: 579.64, angle: -0.3515, scale: 1, mirror: 1 },
//   { sprite: 'mint_twist', x: 1358.83, y: 632.7, angle: 0.5237, scale: 1, mirror: 1, blurry: true },
// ];

// const SIDE_PIECES = [
//   { sprite: 'gold_sharp', x: 226, y: 410, angle: 0.55, scale: 0.4, mirror: 1, extra: true },
//   { sprite: 'mint_sharp_b2', x: 34, y: 420, angle: -0.95, scale: 0.55, mirror: -1, blurry: true, extra: true },
//   { sprite: 'gold_bokeh', x: 292, y: 712, angle: 0.9, scale: 0.85, mirror: 1, blurry: true, extra: true },
//   { sprite: 'mint_soft', x: 182, y: 652, angle: 0.35, scale: 0.52, mirror: 1, extra: true },
//   { sprite: 'gold_sharp_b2', x: 318, y: 214, angle: -1.15, scale: 0.27, mirror: -1, extra: true },
//   { sprite: 'mint_sharp', x: 1238, y: 212, angle: 0.8, scale: 0.42, mirror: 1, extra: true },
//   { sprite: 'gold_soft', x: 1190, y: 548, angle: -0.55, scale: 0.58, mirror: -1, extra: true },
//   { sprite: 'mint_bokeh', x: 1424, y: 160, angle: 0.3, scale: 0.72, mirror: 1, blurry: true, extra: true },
//   { sprite: 'gold_sharp_b5', x: 1238, y: 740, angle: 1.25, scale: 0.5, mirror: 1, blurry: true, extra: true },
//   { sprite: 'mint_sharp_b2', x: 1046, y: 176, angle: -0.6, scale: 0.28, mirror: 1, extra: true },
// ];

// const MORE_PIECES = [
//   { sprite: 'mint_sharp', x: 265, y: 300, angle: 1.2, scale: 0.3, mirror: 1, extra: true },
//   { sprite: 'gold_sharp_b2', x: 60, y: 140, angle: 0.4, scale: 0.35, mirror: 1, extra: true },
//   { sprite: 'gold_soft', x: 300, y: 560, angle: -0.9, scale: 0.32, mirror: -1, extra: true },
//   { sprite: 'mint_sharp_b5', x: 22, y: 760, angle: 0.7, scale: 0.6, mirror: 1, blurry: true, extra: true },
//   { sprite: 'gold_sharp', x: 1180, y: 420, angle: -1, scale: 0.3, mirror: -1, extra: true },
//   { sprite: 'mint_soft', x: 1418, y: 470, angle: 0.5, scale: 0.4, mirror: 1, extra: true },
//   { sprite: 'gold_sharp_b2', x: 1130, y: 662, angle: 0.9, scale: 0.3, mirror: 1, extra: true },
//   { sprite: 'mint_sharp', x: 1345, y: 245, angle: -0.4, scale: 0.26, mirror: 1, extra: true },
//   { sprite: 'gold_sharp_b2', x: 520, y: 190, angle: 0.3, scale: 0.22, mirror: 1, extra: true },
//   { sprite: 'mint_sharp_b2', x: 905, y: 212, angle: -0.8, scale: 0.2, mirror: 1, extra: true },
//   { sprite: 'gold_sharp_b2', x: 470, y: 722, angle: 1.1, scale: 0.25, mirror: 1, extra: true },
//   { sprite: 'mint_sharp', x: 985, y: 735, angle: -0.5, scale: 0.24, mirror: 1, extra: true },
// ];

/*  */

// const FRAME_WIDTH = 1440;
// const HERO_HEIGHT = 786;
// const CENTER_X = 720;
// const CENTER_Y = 393;
// const TAU = Math.PI * 2;
// const STEP = 1 / 60;

// const SPRITE_NAMES = ['gold_sharp', 'gold_sharp_b2', 'gold_sharp_b5', 'gold_soft', 'gold_bokeh', 'mint_sharp', 'mint_sharp_b2', 'mint_sharp_b5', 'mint_soft', 'mint_twist', 'mint_bokeh', 'gold_sharp_fly', 'gold_soft_fly', 'gold_bokeh_fly', 'mint_twist_fly', 'mint_bokeh_fly'];

// const DEPTH_SPRITES = {
//   gold: [
//     ['gold_sharp', 'gold_sharp', 'gold_soft'],
//     ['gold_sharp_b2', 'gold_soft'],
//     ['gold_sharp_b5', 'gold_bokeh'],
//   ],
//   mint: [
//     ['mint_sharp', 'mint_sharp', 'mint_soft'],
//     ['mint_sharp_b2', 'mint_soft', 'mint_twist'],
//     ['mint_sharp_b5', 'mint_twist', 'mint_bokeh'],
//   ],
// };
// const GLITTER = ['gold_sharp', 'mint_sharp', 'gold_soft'];
// const SPARKS = ['gold_bokeh', 'gold_soft', 'gold_sharp_b2'];
// const BLURRED = {
//   gold_sharp: 'gold_sharp_fly',
//   gold_soft: 'gold_soft_fly',
//   gold_bokeh: 'gold_bokeh_fly',
//   mint_twist: 'mint_twist_fly',
//   mint_bokeh: 'mint_bokeh_fly',
//   mint_sharp: 'mint_sharp_b5',
//   mint_sharp_b2: 'mint_sharp_b5',
//   mint_soft: 'mint_sharp_b5',
//   gold_sharp_b2: 'gold_sharp_b5',
//   gold_sharp_b5: 'gold_sharp_b5',
//   mint_sharp_b5: 'mint_sharp_b5',
// };

// const clamp = (v, a, b) => (v < a ? a : v > b ? b : v);
// const smooth = (t) => {
//   t = clamp(t, 0, 1);
//   return t * t * (3 - 2 * t);
// };
// const easeOut = (t, p = 3) => 1 - Math.pow(1 - clamp(t, 0, 1), p);
// const easeInOut = (t) => {
//   t = clamp(t, 0, 1);
//   return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
// };

// function createRandom(seed) {
//   let a = seed >>> 0;
//   return () => {
//     a = (a + 0x6d2b79f5) >>> 0;
//     let t = a;
//     t = Math.imul(t ^ (t >>> 15), t | 1);
//     t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
//     return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
//   };
// }

// function randomDepth(random) {
//   const q = random();
//   if (q < 0.1) return 0.6 + q * 3.5;
//   if (q < 0.42) return -0.35 - (q - 0.1) * 1.7;
//   return -0.3 + (q - 0.42) * 1.25;
// }

// function buildMipmaps(image) {
//   let w = image.naturalWidth;
//   let h = image.naturalHeight;
//   let source = image;
//   const levels = [{ image, w, h }];
//   while (h > 20) {
//     w = Math.max(1, Math.round(w / 2));
//     h = Math.max(1, Math.round(h / 2));
//     const canvas = document.createElement('canvas');
//     canvas.width = w;
//     canvas.height = h;
//     const ctx = canvas.getContext('2d');
//     ctx.imageSmoothingEnabled = true;
//     ctx.imageSmoothingQuality = 'high';
//     ctx.drawImage(source, 0, 0, w, h);
//     levels.push({ image: canvas, w, h });
//     source = canvas;
//   }
//   return levels;
// }

// class Confetti {
//   constructor({ back, front, pieces, show, spritePath = '/static/img/anniversary/' }) {
//     this.back = back;
//     this.front = front;
//     this.backCtx = back.getContext('2d');
//     this.frontCtx = front.getContext('2d');
//     this.pieces = pieces;
//     this.show = show;
//     this.spritePath = spritePath;
//     this.sprites = {};
//     this.running = false;
//     this.tick = this.tick.bind(this);
//   }

//   async load() {
//     await Promise.all(
//       SPRITE_NAMES.map(async (name) => {
//         const image = new Image();
//         image.src = `${this.spritePath}${name}.png`;
//         await image.decode();
//         this.sprites[name] = buildMipmaps(image);
//       }),
//     );
//     this.reset();
//   }

//   resize() {
//     const { width, height } = this.back.getBoundingClientRect();
//     const dpr = Math.min(2, window.devicePixelRatio || 1);
//     for (const canvas of [this.back, this.front]) {
//       canvas.width = Math.round(width * dpr);
//       canvas.height = Math.round(height * dpr);
//     }
//     this.scale = Math.min(1, width / FRAME_WIDTH);
//     this.k = this.scale * dpr;
//     this.ox = ((width - FRAME_WIDTH * this.scale) / 2) * dpr;
//     this.bottom = height / this.scale;
//   }

//   start() {
//     if (this.running || !this.heroes) return;
//     this.running = true;
//     this.last = 0;
//     this.acc = 0;
//     requestAnimationFrame(this.tick);
//   }

//   stop() {
//     this.running = false;
//   }

//   skip(seconds) {
//     for (let i = 0; i < Math.round(seconds / STEP); i++) this.step();
//   }

//   tick(now) {
//     if (!this.running) return;
//     const dt = this.last ? Math.min(0.1, (now - this.last) / 1000) : STEP;
//     this.last = now;
//     this.acc += dt;
//     let steps = 0;
//     while (this.acc >= STEP && steps < 8) {
//       this.step();
//       this.acc -= STEP;
//       steps++;
//     }
//     if (steps === 8) this.acc = 0;
//     this.draw();
//     requestAnimationFrame(this.tick);
//   }

//   reset() {
//     const show = this.show;
//     this.random = createRandom(show.seed);
//     this.T = 0;
//     this.eventIndex = 0;
//     this.debris = [];
//     this.rockets = [];
//     this.flashes = [];
//     const r = this.random;
//     this.heroes = this.pieces.map((p) => {
//       const S = p.scale;
//       const amp = (0.5 + 0.5 * S) * (p.blurry ? 1.45 : 1);
//       return {
//         n: p.sprite,
//         tx: p.x,
//         ty: p.y,
//         ta: p.angle,
//         S,
//         m: p.mirror,
//         extra: !!p.extra,
//         spr: this.sprites[p.sprite],
//         fly: this.sprites[BLURRED[p.sprite] || p.sprite],
//         vis: false,
//         x: CENTER_X,
//         y: CENTER_Y,
//         a: p.angle,
//         s: S,
//         flip: 0,
//         blur: 0,
//         alpha: 0,
//         t0: 0,
//         ix: (2.5 + r() * 2.5) * amp,
//         iy: (4 + r() * 3) * amp,
//         wx: TAU * (0.14 + r() * 0.09),
//         wy: TAU * (0.17 + r() * 0.1),
//         px: r() * TAU,
//         py: r() * TAU,
//         ia: 0.02 + r() * 0.02,
//         wa: TAU * (0.12 + r() * 0.07),
//         pa: r() * TAU,
//         ifl: 0.04 + r() * 0.05,
//         wf: TAU * (0.1 + r() * 0.07),
//         pf: r() * TAU,
//         glint: p.sprite === 'gold_sharp' ? (S > 0.8 ? 0.38 : 0.25) : p.sprite === 'gold_soft' ? 0.2 : p.sprite === 'mint_sharp' ? 0.2 : 0,
//         wg: TAU * (0.15 + r() * 0.08),
//         pg: r() * TAU,
//       };
//     });
//   }

//   rnd(a, b) {
//     return a + this.random() * (b - a);
//   }

//   pick(list) {
//     return list[(this.random() * list.length) | 0];
//   }

//   sign() {
//     return this.random() < 0.5 ? -1 : 1;
//   }

//   flash(x, y, r, rgb, a, life) {
//     this.flashes.push({ x, y, r, rgb, a, age: 0, life });
//   }

//   piece(x, y, vx, vy, o) {
//     const d = clamp(o.d, -1, 1);
//     const ad = Math.abs(d);
//     const band = ad < 0.28 ? 0 : ad < 0.6 ? 1 : 2;
//     const color = this.random() < (o.gold == null ? 0.6 : o.gold) ? 'gold' : 'mint';
//     const spr = this.sprites[this.pick(o.set || DEPTH_SPRITES[color][band])];
//     const p = {
//       x,
//       y,
//       vx,
//       vy,
//       d,
//       pf: Math.pow(2, d * 0.75),
//       spr,
//       h: (o.size || 38) * Math.pow(2, d * 1.05) * this.rnd(0.8, 1.2),
//       rot: this.rnd(0, TAU),
//       vr: this.rnd(-1, 1) * (o.spin || 4),
//       flip: this.rnd(0, TAU),
//       vflip: this.sign() * this.rnd(5, 12),
//       tilt: this.rnd(0, TAU),
//       vtilt: this.rnd(0.8, 3),
//       sway: this.rnd(0, TAU),
//       vsway: this.rnd(0.6, 1.5),
//       swayA: this.rnd(25, 60),
//       age: 0,
//       life: (o.life || 5) * this.rnd(0.85, 1.15),
//       k0: o.k0 == null ? 1.4 : o.k0,
//       k1: o.k1 == null ? 2.6 : o.k1,
//       ramp: o.ramp || 0.9,
//       g: o.g == null ? 1 : o.g,
//       gOff: this.rnd(0, TAU),
//       shine: band === 0 ? 1 : band === 1 ? 0.55 : 0.25,
//       a0: (o.alpha == null ? 1 : o.alpha) * (d < 0 ? 0.45 + 0.55 * (1 + d) : 1) * (band === 2 && d > 0 ? 0.75 : 1),
//       layer: d > 0.55 ? 1 : 0,
//       fadeIn: o.fadeIn || 0.05,
//       tail: o.tail || 0.9,
//       fadeAt: 1e9,
//       fadeDur: 1,
//       ts: 1,
//     };
//     this.debris.push(p);
//     const cleanup = this.show.cleanup;
//     if (!o.keep) {
//       p.fadeAt = this.rnd(cleanup[0], cleanup[1]);
//       p.fadeDur = this.rnd(cleanup[2], cleanup[3]);
//       p.life = Math.max(p.life, 60);
//     }
//   }

//   burst(x, y, o) {
//     for (let i = 0; i < o.n; i++) {
//       const z = this.rnd(-1, 1);
//       const th = this.rnd(0, TAU);
//       const r = Math.sqrt(1 - z * z);
//       const s = o.core && this.random() < o.core ? this.rnd(70, 300) : this.rnd(o.vmin, o.vmax);
//       let dx = r * Math.cos(th);
//       const dy = r * Math.sin(th);
//       if (o.outward && this.random() < o.outward[1]) dx = Math.abs(dx) * o.outward[0];
//       this.piece(x + this.rnd(-4, 4), y + this.rnd(-4, 4), dx * s * (o.ex || 1), dy * s, {
//         d: randomDepth(this.random),
//         gold: o.gold,
//         size: o.size,
//         life: o.life,
//         k0: o.k0,
//         k1: o.k1,
//         ramp: o.ramp,
//         g: o.g,
//         set: o.set,
//         alpha: o.alpha,
//       });
//     }
//   }

//   rocket(xb, yb, t0, t1, onBurst, o = {}) {
//     this.rockets.push({
//       x0: xb + this.rnd(-30, 30),
//       y0: HERO_HEIGHT + 24,
//       xb,
//       yb,
//       t0,
//       t1,
//       onBurst,
//       d: o.d || 0,
//       acc: 0,
//       seed: this.rnd(0, 99),
//       x: xb,
//       y: HERO_HEIGHT + 24,
//     });
//   }

//   landPieces(o) {
//     const T = this.T;
//     for (const h of this.heroes) {
//       if (o.filter && !o.filter(h)) continue;
//       const main = h.n === 'gold_sharp' && h.S > 0.8;
//       h.vis = true;
//       h.bx = o.origin[0];
//       h.by = o.origin[1];
//       h.t0 = T;
//       h.D = this.rnd(o.D[0], o.D[1]) + (main ? 0.06 : 0) + (h.extra ? this.rnd(-0.12, 0.08) : 0);
//       h.p = o.p || 3.2;
//       h.arc = this.rnd(o.arc[0], o.arc[1]) * this.sign();
//       h.spin = this.rnd(o.spin[0], o.spin[1]) * this.sign();
//       h.nf = Math.round(this.rnd(o.nf[0], o.nf[1]));
//       h.s0 = o.s0;
//       h.bf0 = main ? o.focusLast : this.rnd(o.bf[0], o.bf[1]);
//       h.bfw = o.bfw;
//     }
//   }

//   step() {
//     const show = this.show;
//     const dt = STEP;
//     this.T += dt;
//     const T = this.T;
//     while (this.eventIndex < show.events.length && show.events[this.eventIndex][0] <= T) {
//       show.events[this.eventIndex][1](this);
//       this.eventIndex++;
//     }

//     const tau = show.tau(T);
//     const sdt = dt * tau;

//     for (let i = this.rockets.length - 1; i >= 0; i--) {
//       const r = this.rockets[i];
//       if (T < r.t0) continue;
//       const u = (T - r.t0) / (r.t1 - r.t0);
//       const e = easeOut(u, 2.1);
//       r.x = r.x0 + (r.xb - r.x0) * u + Math.sin(T * 9 + r.seed) * 3;
//       r.y = r.y0 + (r.yb - r.y0) * e;
//       r.acc += dt * 80 * (1 - e * 0.6);
//       while (r.acc >= 1) {
//         r.acc -= 1;
//         this.piece(r.x + this.rnd(-2, 2), r.y + this.rnd(0, 6), this.rnd(-22, 22), this.rnd(10, 70), {
//           d: r.d,
//           set: SPARKS,
//           size: this.rnd(9, 15),
//           life: this.rnd(0.35, 0.7),
//           k0: 2.5,
//           k1: 3,
//           ramp: 0.5,
//           g: 0.35,
//           alpha: 0.7,
//           spin: 6,
//           fadeIn: 0.02,
//           tail: 0.35,
//           keep: true,
//         });
//       }
//       if (u >= 1) {
//         this.rockets.splice(i, 1);
//         r.onBurst(this, r.xb, r.yb);
//       }
//     }

//     const wind = 14 * Math.sin(T * 0.31) + 9 * Math.sin(T * 0.83 + 1.7);
//     const D = this.debris;
//     for (let i = D.length - 1; i >= 0; i--) {
//       const p = D[i];
//       p.ts = tau;
//       if (sdt > 0) {
//         const c = Math.abs(Math.cos(p.flip));
//         const k = (p.k0 + (p.k1 - p.k0) * smooth(p.age / p.ramp)) * (0.45 + c);
//         const dec = Math.exp(-k * sdt);
//         p.vx = p.vx * dec + (wind + Math.sin(p.sway) * p.swayA) * p.pf * sdt;
//         p.vy = p.vy * dec + 430 * p.g * (1 + show.sink * (1 - tau)) * p.pf * sdt;
//         p.x += p.vx * sdt;
//         p.y += p.vy * sdt;
//         p.rot += p.vr * sdt;
//         p.flip += p.vflip * sdt;
//         p.tilt += p.vtilt * sdt;
//         p.sway += p.vsway * sdt;
//         p.age += sdt;
//       }
//       if (p.age > p.life || p.y > this.bottom + 160 || p.x < -300 || p.x > FRAME_WIDTH + 300 || p.y < -700) {
//         D[i] = D[D.length - 1];
//         D.pop();
//       }
//     }

//     for (const h of this.heroes) {
//       if (!h.vis) continue;
//       const u = (T - h.t0) / h.D;
//       const e = easeOut(u, h.p);
//       const dx = h.tx - h.bx;
//       const dy = h.ty - h.by;
//       const len = Math.hypot(dx, dy) || 1;
//       const bend = Math.sin(Math.PI * e) * h.arc;
//       h.x = h.bx + dx * e - (dy / len) * bend;
//       h.y = h.by + dy * e + (dx / len) * bend;
//       h.a = h.ta + h.spin * (1 - e);
//       h.flip = h.nf * TAU * (1 - e);
//       h.s = h.S * (h.s0 + (1 - h.s0) * easeOut(u, 2.4));
//       h.blur = 1 - smooth((u - h.bf0) / h.bfw);
//       h.alpha = smooth(u / 0.07);
//     }

//     for (let i = this.flashes.length - 1; i >= 0; i--) {
//       this.flashes[i].age += dt;
//       if (this.flashes[i].age > this.flashes[i].life) this.flashes.splice(i, 1);
//     }
//   }

//   drawSprite(ctx, levels, scale, x, y, angle, sx, sy, alpha) {
//     if (alpha <= 0.002) return;
//     const target = levels[0].h * scale * this.k;
//     let level = levels[0];
//     for (let j = levels.length - 1; j >= 0; j--) {
//       if (levels[j].h >= target * 0.9) {
//         level = levels[j];
//         break;
//       }
//     }
//     const S = target / level.h;
//     const cos = Math.cos(angle);
//     const sin = Math.sin(angle);
//     ctx.setTransform(cos * sx * S, sin * sx * S, -sin * sy * S, cos * sy * S, this.ox + x * this.k, y * this.k);
//     ctx.globalAlpha = Math.min(1, alpha);
//     ctx.drawImage(level.image, -level.w / 2, -level.h / 2);
//   }

//   draw() {
//     const b = this.backCtx;
//     const f = this.frontCtx;
//     const T = this.T;
//     if (!this.heroes) return;
//     for (const ctx of [b, f]) {
//       ctx.setTransform(1, 0, 0, 1, 0, 0);
//       ctx.globalAlpha = 1;
//       ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
//       ctx.globalCompositeOperation = 'lighter';
//     }

//     for (const fl of this.flashes) {
//       const q = fl.age / fl.life;
//       const a = fl.a * (1 - q) * (1 - q);
//       const r = fl.r * (0.75 + 0.25 * q);
//       b.setTransform(this.k, 0, 0, this.k, this.ox, 0);
//       b.globalAlpha = 1;
//       const g = b.createRadialGradient(fl.x, fl.y, 0, fl.x, fl.y, r);
//       g.addColorStop(0, `rgba(${fl.rgb},${a})`);
//       g.addColorStop(0.3, `rgba(${fl.rgb},${a * 0.35})`);
//       g.addColorStop(1, `rgba(${fl.rgb},0)`);
//       b.fillStyle = g;
//       b.fillRect(fl.x - r, fl.y - r, r * 2, r * 2);
//     }

//     const bokeh = this.sprites.gold_bokeh;
//     for (const r of this.rockets) {
//       if (T < r.t0) continue;
//       this.drawSprite(b, bokeh, 0.46, r.x, r.y, 0, 1, 1, 0.22);
//       this.drawSprite(b, bokeh, 0.18, r.x, r.y, 0, 0.8, 1, 0.9);
//     }

//     for (const p of this.debris) {
//       const out = smooth((T - p.fadeAt) / p.fadeDur);
//       const fade = smooth(p.age / p.fadeIn) * (1 - smooth((p.age - (p.life - p.tail)) / p.tail)) * (1 - out);
//       if (fade <= 0.003) continue;
//       const c = Math.cos(p.flip);
//       const ac = Math.abs(c);
//       const sx = Math.max(0.07, ac) * (c < 0 ? -1 : 1);
//       const sy = 0.82 + 0.18 * Math.cos(p.tilt);
//       const alpha = p.a0 * fade * (0.42 + 0.58 * ac) * (c < 0 ? 0.72 : 1);
//       const ctx = p.layer ? f : b;
//       const scale = (p.h / p.spr[0].h) * (1 - 0.3 * out);
//       this.drawSprite(ctx, p.spr, scale, p.x, p.y, p.rot, sx, sy, alpha);
//       const glint = Math.pow(Math.max(0, Math.cos(p.flip - p.gOff)), 16) * p.shine * Math.min(1, p.ts);
//       if (glint > 0.05) this.drawSprite(ctx, p.spr, scale, p.x, p.y, p.rot, sx, sy, alpha * glint * 1.1);
//     }

//     const rest = smooth((T - this.show.settle) / 1.6);
//     for (const h of this.heroes) {
//       if (!h.vis || h.alpha <= 0) continue;
//       const x = h.x + Math.sin(T * h.wx + h.px) * h.ix * rest;
//       const y = h.y + Math.sin(T * h.wy + h.py) * h.iy * rest;
//       const angle = h.a + Math.sin(T * h.wa + h.pa) * h.ia * rest;
//       const c = Math.cos(h.flip);
//       const ac = Math.abs(c);
//       const breath = 1 - h.ifl * (0.5 - 0.5 * Math.cos(T * h.wf + h.pf)) * rest;
//       const sx = Math.max(0.07, ac) * (c < 0 ? -1 : 1) * breath * h.m;
//       const alpha = h.alpha * (0.42 + 0.58 * ac) * (c < 0 ? 0.72 : 1);
//       this.drawSprite(b, h.spr, h.s, x, y, angle, sx, 1, alpha * (1 - h.blur));
//       if (h.blur > 0.002) this.drawSprite(b, h.fly, h.s, x, y, angle, sx, 1, alpha * h.blur);
//       if (h.glint && rest > 0) {
//         const glint = Math.pow(Math.max(0, Math.sin(T * h.wg + h.pg)), 14) * h.glint * rest;
//         if (glint > 0.01) this.drawSprite(b, h.spr, h.s, x, y, angle, sx, 1, glint);
//       }
//     }
//     b.globalAlpha = 1;
//     f.globalAlpha = 1;
//   }
// }

/*  */

// const GOLD = '255,214,160';
// const MINT = '150,240,200';

// function salvo(fx, x, y, side) {
//   const outward = [side, 0.8];
//   const physics = { g: 0.22, k0: 1.5, ramp: 1.0, life: 9 };
//   fx.flash(x, y, 380, side < 0 ? GOLD : MINT, 0.36, 0.85);
//   fx.burst(x, y, { ...physics, n: 175, vmin: 380, vmax: 900, ex: 1.15, k1: 2.4, size: 40, gold: side < 0 ? 0.65 : 0.45, core: 0.18, outward });
//   fx.burst(x, y, { ...physics, n: 30, vmin: 320, vmax: 950, ex: 1.15, k0: 1.6, k1: 2.6, size: 15, set: GLITTER, alpha: 0.85, outward });
//   fx.landPieces({
//     origin: [x, y],
//     filter: (h) => (side < 0 ? h.tx < CENTER_X : h.tx >= CENTER_X),
//     D: [1.95, 2.12],
//     s0: 0.4,
//     arc: [30, 90],
//     spin: [4, 8],
//     nf: [2, 3],
//     bf: [0.5, 0.7],
//     focusLast: 0.72,
//     bfw: 0.26,
//   });
// }

// const TWO_SALVOS = {
//   seed: 181,
//   settle: 3.45,
//   sink: 2.5,
//   cleanup: [2.3, 5.0, 1.1, 1.8],
//   tau: (T) => 1 - 0.8 * easeInOut((T - 2.0) / 1.4),
//   events: [
//     [0, (fx) => fx.rocket(250, 330, 0, 0.8, (fx, x, y) => salvo(fx, x, y, -1), { d: -0.05 })],
//     [0.45, (fx) => fx.rocket(1190, 300, 0.45, 1.25, (fx, x, y) => salvo(fx, x, y, 1), { d: -0.05 })],
//   ],
// };

/*  */

// const stage = document.querySelector('[data-stage]');
// const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

// const confetti = new Confetti({
//   back: document.querySelector('[data-stage-confetti-back]'),
//   front: document.querySelector('[data-stage-confetti-front]'),
//   pieces: [...DESIGN_PIECES, ...SIDE_PIECES, ...MORE_PIECES],
//   show: TWO_SALVOS,
//   spritePath: '/static/img/anniversary/',
// });

// new ResizeObserver(() => {
//   confetti.resize();
//   confetti.draw();
// }).observe(stage);

// confetti.load().then(() => {
//   confetti.resize();
//   if (reducedMotion) {
//     confetti.skip(8);
//     confetti.draw();
//     return;
//   }
//   new IntersectionObserver(([entry]) => {
//     if (entry.isIntersecting) confetti.start();
//     else confetti.stop();
//   }).observe(stage);
// });

/*  */

document.addEventListener('DOMContentLoaded', (e) => {
  initAccordion();

  /*  */

  const lotteryCard = document.querySelector('[data-lottery-card]');
  const lotteryCardCloseButton = lotteryCard.querySelector('[data-lottery-card-close]');

  lotteryCardCloseButton.addEventListener('click', () => {
    lotteryCard.classList.add('is_hidden');
  });
  /*  */

  const accountTypeSlider = initSlider('[data-account-type-slider]', thumbsSliderOptions);
  const assetTypeSlider = initSlider('[data-asset-type-slider]', thumbsSliderOptions);
  const accountInfoSlider = initSlider('[data-account-info-slider]', accountInfoSliderOptions);
  const assetInfoSlider = initSlider('[data-asset-info-slider]', assetInfoSliderOptions);

  /*  */

  const parallaxHorizontalCards = document.querySelectorAll('[data-parallax-horizontal-card]');
  const parallaxVerticalCards = document.querySelectorAll('[data-parallax-vertical-card]');

  initSimpleParallax(parallaxHorizontalCards, parallaxHorizontalOptions);
  initSimpleParallax(parallaxVerticalCards, parallaxVerticalOptions);
});
